import { RouteRecordRaw } from 'vue-router'
import { Layout } from '@/routers/constant'

const router: Array<RouteRecordRaw> = [
  {
    path: '/business/evaluate',
    component: Layout,
    redirect: '/business/evaluate/index',
    meta: {
      title: '评价管理',
      keepAlive: true,
      requiresAuth: true
    },
    children: [
      {
        path: 'goods/index',
        name: 'BusinessEvaluateGoodsIndex',
        component: () => import('@/views/business/evaluate/goods/index.vue'),
        meta: {
          keepAlive: true,
          requiresAuth: true,
          title: '商品评价'
        }
      },
      {
        path: 'clinic/index',
        name: 'BusinessEvaluateClinicIndex',
        component: () => import('@/views/business/evaluate/clinic/index.vue'),
        meta: {
          keepAlive: true,
          requiresAuth: true,
          title: '机构评价'
        }
      },
      {
        path: 'doctor/index',
        name: 'BusinessEvaluateDoctorIndex',
        component: () => import('@/views/business/evaluate/doctor/index.vue'),
        meta: {
          keepAlive: true,
          requiresAuth: true,
          title: '医护评价'
        }
      }
    ]
  }
]

export default router
